module.exports = __webpack_public_path__ + "static/media/r_size.c3ba3081.jpg";